export type DownloadOptions = {
  utf8WithBom?: boolean,
  mimeType?: string
}

/**
 * Based on https://github.com/mui-org/material-ui-x/blob/d1d0793c1b4aaa4acc759963a8ef69d55cf619a4/packages/grid/_modules_/grid/utils/exportAs.ts
 */
export const downloadFile = (
  content: Blob | string,
  filename: string = document.title,
  extension: string = 'txt',
  downloadOptions: DownloadOptions = {
    utf8WithBom: true,
    mimeType: 'text/plain',
  },
): void => {
  const fullName = `${filename}.${extension}`
  if ('download' in HTMLAnchorElement.prototype) {
    let blob: Blob

    if (typeof content == 'string') {
      blob = new Blob([downloadOptions.utf8WithBom ? new Uint8Array([0xef, 0xbb, 0xbf]) : '', content], {
        type: downloadOptions.mimeType,
      })
    } else {
      blob = content
    }

    // Create an object URL for the blob object
    const url = URL.createObjectURL(blob)

    // Create a new anchor element
    const a = document.createElement('a')
    a.href = url
    a.download = fullName

    // Programmatically trigger a click on the anchor element
    // Useful if you want the download to happen automatically
    // Without attaching the anchor element to the DOM
    a.click()

    // https://github.com/eligrey/FileSaver.js/issues/205
    setTimeout(() => {
      URL.revokeObjectURL(url)
    })
    return
  }

  throw new Error('downloadFile is not supported')
}